import React, { useEffect, useRef } from 'react';
import { Sparkles } from 'lucide-react';
import './ProCelebration.css';

const PLAN_LABELS = {
  monthly: 'Monthly Plan',
  '3month': '3-Month Plan',
  '6month': '6-Month Plan',
};

const CONFETTI_COLORS = [
  '#2563EB', '#14B8A6', '#F59E0B', '#10B981', '#EC4899',
  '#8B5CF6', '#EF4444', '#F97316', '#06B6D4', '#84CC16',
];

const NUM_PIECES = 38;

const ProCelebration = ({ plan, onClose }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setTimeout(onClose, 5000);
    return () => clearTimeout(timerRef.current);
  }, [onClose]);

  const pieces = Array.from({ length: NUM_PIECES }, (_, i) => ({
    id: i,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    left: Math.random() * 100,
    delay: Math.random() * 1.8,
    duration: 2.4 + Math.random() * 1.6,
    size: 7 + Math.random() * 7,
    rotation: Math.random() * 360,
    isRect: Math.random() > 0.5,
  }));

  return (
    <div className="procelebration-overlay" onClick={onClose}>
      <div className="procelebration-confetti" aria-hidden="true">
        {pieces.map(p => (
          <div
            key={p.id}
            className="procelebration-piece"
            style={{
              left: `${p.left}%`,
              animationDelay: `${p.delay}s`,
              animationDuration: `${p.duration}s`,
              width: p.isRect ? `${p.size}px` : `${p.size * 0.7}px`,
              height: p.isRect ? `${p.size * 0.45}px` : `${p.size * 0.7}px`,
              background: p.color,
              borderRadius: p.isRect ? '2px' : '50%',
              transform: `rotate(${p.rotation}deg)`,
            }}
          />
        ))}
      </div>

      <div className="procelebration-card" onClick={e => e.stopPropagation()}>
        <div className="procelebration-icon"><Sparkles size={48} strokeWidth={1.5} /></div>
        <h2 className="procelebration-title">Welcome to Pro!</h2>
        <p className="procelebration-plan">{PLAN_LABELS[plan] || 'Pro Plan'} activated</p>
        <p className="procelebration-desc">
          You now have <strong>300 AI credits / month</strong> and full access to every feature.
        </p>
        <button className="procelebration-btn" onClick={onClose}>
          Let's go →
        </button>
        <div className="procelebration-auto">Closes automatically in a few seconds</div>
      </div>
    </div>
  );
};

export default ProCelebration;
